import {
	CLEAR_OFFER_MANAGEMENT_STATE,
	GET_ALL_OFFERS,
	GET_ALL_OFFERS_SUCCESS,
	GET_ALL_OFFERS_ERROR,
	GET_OFFER_BY_ID,
	GET_OFFER_BY_ID_SUCCESS,
	GET_OFFER_BY_ID_ERROR,
	CREATE_OFFER,
	CREATE_OFFER_SUCCESS,
	CREATE_OFFER_ERROR,
	UPDATE_OFFER,
	UPDATE_OFFER_SUCCESS,
	UPDATE_OFFER_ERROR,
	DELETE_OFFER,
	DELETE_OFFER_SUCCESS,
	DELETE_OFFER_ERROR,
	GET_ALL_ORIGINATORS,
	GET_ALL_ORIGINATORS_SUCCESS,
	GET_ALL_ORIGINATORS_ERROR,
	GET_ALL_INDUSTRY,
	GET_ALL_INDUSTRY_SUCCESS,
	GET_ALL_INDUSTRY_ERROR,
	GET_ALL_OPERATION,
	GET_ALL_OPERATION_SUCCESS,
	GET_ALL_OPERATION_ERROR,
	GET_ALL_OFFER_STATUS,
	GET_ALL_OFFER_STATUS_SUCCESS,
	GET_ALL_OFFER_STATUS_ERROR,
	GET_ALL_INDEXER,
	GET_ALL_INDEXER_SUCCESS,
	GET_ALL_INDEXER_ERROR,
	GET_ALL_STRUCTURER,
	GET_ALL_STRUCTURER_SUCCESS,
	GET_ALL_STRUCTURER_ERROR,
	GET_ALL_DOC_TYPE,
	GET_ALL_DOC_TYPE_SUCCESS,
	GET_ALL_DOC_TYPE_ERROR,
	GET_ALL_DOC_SUBTYPE,
	GET_ALL_DOC_SUBTYPE_SUCCESS,
	GET_ALL_DOC_SUBTYPE_ERROR,
	GET_ALL_EMAIL_USERS,
	GET_ALL_EMAIL_USERS_SUCCESS,
	GET_ALL_EMAIL_USERS_ERROR,
  UPLOAD_OFFER_WALLET,
  UPLOAD_OFFER_WALLET_SUCCESS,
  UPLOAD_OFFER_WALLET_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const OFFER_URL = '/offers';
const ORIGINATOR_URL = '/originator';
const INDUSTRY_URL = '/industryType';
const OPERATIONS_URL = '/operationType';
const STATUS_URL = '/offerStatus';
const INDEXER_URL = '/indexers';
const STRUCTURER_URL = '/structurer';
const DOC_TYPE_URL = '/docType';
const DOC_SUBTYPE_URL = '/docSubtype';
const USER_URL = '/users';

const defaultState = () => ({
	offerList: [],
	isLoadingOffers: '',
	isLoadingOriginators: '',
	isLoadingIndustries: '',
	isLoadingOperation: '',
	isLoadingStatus: '',
	isLoadingIndexer: '',
	isLoadingStructurer: '',
	isLoadingDocType: '',
	isLoadingDocSubtype: '',
	offerOriginators: [],
	offerIndustries: [],
	offerOperations: [],
	offerStatus: [],
	offerIndexers: [],
	offerStructurers: [],
	offerDocTypes: [],
	offerDocSubtypes: [],
	offerEmailUsers: [],
	originator: [],
});

const state = defaultState();

const getters = {
	offerList: (state) => state.offerList,
	isLoadingOffers: (state) => state.isLoadingOffers === 'loading',
	isLoadingOriginators: (state) => state.isLoadingOriginators === 'loading',
	isLoadingOperation: (state) => state.isLoadingOperation === 'loading',
	isLoadingIndustries: (state) => state.isLoadingIndustries === 'loading',
	isLoadingStatus: (state) => state.isLoadingStatus === 'loading',
	isLoadingIndexer: (state) => state.isLoadingIndexer === 'loading',
	isLoadingStructurer: (state) => state.isLoadingStructurer === 'loading',
	isLoadingDocType: (state) => state.isLoadingDocType === 'loading',
	isLoadingDocSubtype: (state) => state.isLoadingDocSubtype === 'loading',
	offerOriginators: (state) => state.offerOriginators,
	originator: (state) => state.originator,
	offerIndustries: (state) => state.offerIndustries,
	offerOperations: (state) => state.offerOperations,
	offerStatus: (state) => state.offerStatus,
	offerIndexers: (state) => state.offerIndexers,
	offerStructurers: (state) => state.offerStructurers,
	offerDocTypes: (state) => state.offerDocTypes,
	offerDocSubtypes: (state) => state.offerDocSubtypes,
	offerEmailUsers: (state) => state.offerEmailUsers,
};

const mutations = {
	[CLEAR_OFFER_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_OFFERS]: (state) => {
		state.isLoadingOffers = 'loading';
	},
	[GET_ALL_OFFERS_SUCCESS]: (state, data) => {
		state.offerList = data;
		state.isLoadingOffers = 'success';
	},
	[GET_ALL_OFFERS_ERROR]: (state) => {
		state.isLoadingOffers = 'error';
	},
	[GET_OFFER_BY_ID]: (state) => {
		state.originator = [];
		state.isLoadingOffers = 'loading';
	},
	[GET_OFFER_BY_ID_SUCCESS]: (state, data) => {
		state.originator = data.originator;
		state.isLoadingOffers = 'success';
	},
	[GET_OFFER_BY_ID_ERROR]: (state) => {
		state.originator = [];
		state.isLoadingOffers = 'error';
	},
	[CREATE_OFFER]: (state) => {
		state.isLoadingOffers = 'loading';
	},
	[CREATE_OFFER_SUCCESS]: (state) => {
		state.isLoadingOffers = 'success';
	},
	[CREATE_OFFER_ERROR]: (state) => {
		state.isLoadingOffers = 'error';
	},
	[UPDATE_OFFER]: (state) => {
		state.isLoadingOffers = 'loading';
	},
	[UPDATE_OFFER_SUCCESS]: (state) => {
		state.isLoadingOffers = 'success';
	},
	[UPDATE_OFFER_ERROR]: (state) => {
		state.isLoadingOffers = 'error';
	},
  [UPLOAD_OFFER_WALLET]: (state) => {
		state.isLoadingOffers = 'loading';
	},
	[UPLOAD_OFFER_WALLET_SUCCESS]: (state) => {
		state.isLoadingOffers = 'success';
	},
	[UPLOAD_OFFER_WALLET_ERROR]: (state) => {
		state.isLoadingOffers = 'error';
	},
	[DELETE_OFFER]: (state) => {
		state.isLoadingOffers = 'loading';
	},
	[DELETE_OFFER_SUCCESS]: (state) => {
		state.isLoadingOffers = 'success';
	},
	[DELETE_OFFER_ERROR]: (state) => {
		state.isLoadingOffers = 'error';
	},
	[GET_ALL_ORIGINATORS]: (state) => {
		state.offerOriginators = [];
		state.isLoadingOriginators = 'loading';
	},
	[GET_ALL_ORIGINATORS_SUCCESS]: (state, data) => {
		state.offerOriginators = data.originators;
		state.isLoadingOriginators = 'success';
	},
	[GET_ALL_ORIGINATORS_ERROR]: (state) => {
		state.offerOriginators = [];
		state.isLoadingOriginators = 'error';
	},
	[GET_ALL_INDUSTRY]: (state) => {
		state.offerIndustries = [];
		state.isLoadingIndustries = 'loading';
	},
	[GET_ALL_INDUSTRY_SUCCESS]: (state, data) => {
		state.offerIndustries = data;
		state.isLoadingIndustries = 'success';
	},
	[GET_ALL_INDUSTRY_ERROR]: (state) => {
		state.offerIndustries = [];
		state.isLoadingIndustries = 'error';
	},
	[GET_ALL_OPERATION]: (state) => {
		state.offerOperations = [];
		state.isLoadingOperation = 'loading';
	},
	[GET_ALL_OPERATION_SUCCESS]: (state, data) => {
		state.offerOperations = data;
		state.isLoadingOperation = 'success';
	},
	[GET_ALL_OPERATION_ERROR]: (state) => {
		state.offerOperations = [];
		state.isLoadingOperation = 'error';
	},
	[GET_ALL_OFFER_STATUS]: (state) => {
		state.offerStatus = [];
		state.isLoadingStatus = 'loading';
	},
	[GET_ALL_OFFER_STATUS_SUCCESS]: (state, data) => {
		state.offerStatus = data;
		state.isLoadingStatus = 'success';
	},
	[GET_ALL_OFFER_STATUS_ERROR]: (state) => {
		state.offerStatus = [];
		state.isLoadingStatus = 'error';
	},
	[GET_ALL_INDEXER]: (state) => {
		state.offerIndexers = [];
		state.isLoadingIndexer = 'loading';
	},
	[GET_ALL_INDEXER_SUCCESS]: (state, data) => {
		state.offerIndexers = data;
		state.isLoadingIndexer = 'success';
	},
	[GET_ALL_INDEXER_ERROR]: (state) => {
		state.offerIndexers = [];
		state.isLoadingIndexer = 'error';
	},
	[GET_ALL_STRUCTURER]: (state) => {
		state.offerStructurers = [];
		state.isLoadingStructurer = 'loading';
	},
	[GET_ALL_STRUCTURER_SUCCESS]: (state, data) => {
		state.offerStructurers = data;
		state.isLoadingStructurer = 'success';
	},
	[GET_ALL_STRUCTURER_ERROR]: (state) => {
		state.offerStructurers = [];
		state.isLoadingStructurer = 'error';
	},
	[GET_ALL_DOC_TYPE]: (state) => {
		state.offerDocTypes = [];
		state.isLoadingDocType = 'loading';
	},
	[GET_ALL_DOC_TYPE_SUCCESS]: (state, data) => {
		state.offerDocTypes = data;
		state.isLoadingDocType = 'success';
	},
	[GET_ALL_DOC_TYPE_ERROR]: (state) => {
		state.offerDocTypes = [];
		state.isLoadingDocType = 'error';
	},
	[GET_ALL_DOC_SUBTYPE]: (state) => {
		state.offerDocSubtypes = [];
		state.isLoadingDocSubtype = 'loading';
	},
	[GET_ALL_DOC_SUBTYPE_SUCCESS]: (state, data) => {
		state.offerDocSubtypes = data;
		state.isLoadingDocSubtype = 'success';
	},
	[GET_ALL_DOC_SUBTYPE_ERROR]: (state) => {
		state.offerDocSubtypes = [];
		state.isLoadingDocSubtype = 'error';
	},
	[GET_ALL_EMAIL_USERS]: (state) => {
		state.offerEmailUsers = [];
	},
	[GET_ALL_EMAIL_USERS_SUCCESS]: (state, data) => {
		state.offerEmailUsers = data;
	},
	[GET_ALL_EMAIL_USERS_ERROR]: (state) => {
		state.offerEmailUsers = [];
	},
};

const actions = {
	[GET_ALL_OFFERS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_OFFERS);
			localStorage.setItem(`lastReqAdm`, 'offerManagement/GET_ALL_OFFERS');

			http({
				method: 'GET',
				url: `${OFFER_URL}/all-offers${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_OFFERS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_OFFERS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_OFFER_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_OFFER_BY_ID);

			http({
				method: 'GET',
				url: `${OFFER_URL}/admin/details/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_OFFER_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_OFFER_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_OFFER]: async ({ commit }, { vm, body, params }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_OFFER);

			http({
				method: 'POST',
				url: `${OFFER_URL}/v2/`,
				data: body,
				params,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Oferta criada com sucesso.');
					commit(CREATE_OFFER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_OFFER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_OFFER]: async ({ commit }, { vm, id, body, params }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_OFFER);

			http({
				method: 'PATCH',
				url: `${OFFER_URL}/v2/${id}`,
				data: body,
				params,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Oferta editada com sucesso.');
					commit(UPDATE_OFFER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_OFFER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
  [UPLOAD_OFFER_WALLET]: async ({ commit }, { vm, body, params }) => {
		return new Promise((resolve, reject) => {
			commit(UPLOAD_OFFER_WALLET);

			http({
				method: 'POST',
				url: `${OFFER_URL}/upload/wallet`,
				data: body,
				params,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Upload realizado com sucesso.');
					commit(UPLOAD_OFFER_WALLET_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPLOAD_OFFER_WALLET_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_OFFER]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_OFFER);

			http({
				method: 'DELETE',
				url: `${OFFER_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Oferta excluída com sucesso.');
					commit(DELETE_OFFER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_OFFER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_ORIGINATORS]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_ORIGINATORS);

			http({
				method: 'GET',
				url: `${ORIGINATOR_URL}?limit=10000&page=1`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_ORIGINATORS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_ORIGINATORS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_INDUSTRY]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_INDUSTRY);
			http.defaults.headers.common['Accept-Language'] = 'pt-br';

			http({
				method: 'GET',
				url: `${INDUSTRY_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_INDUSTRY_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_INDUSTRY_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_OPERATION]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_OPERATION);

			http({
				method: 'GET',
				url: `${OPERATIONS_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_OPERATION_SUCCESS, response.data.operationTypes);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_OPERATION_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_OFFER_STATUS]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_OFFER_STATUS);
			http.defaults.headers.common['Accept-Language'] = 'pt-br';

			http({
				method: 'GET',
				url: `${STATUS_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_OFFER_STATUS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_OFFER_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_INDEXER]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_INDEXER);

			http({
				method: 'GET',
				url: `${INDEXER_URL}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_INDEXER_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_INDEXER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_STRUCTURER]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_STRUCTURER);

			http({
				method: 'GET',
				url: `${STRUCTURER_URL}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_STRUCTURER_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_STRUCTURER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_DOC_TYPE]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_TYPE);

			http({
				method: 'GET',
				url: `${DOC_TYPE_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_TYPE_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_TYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_DOC_SUBTYPE]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_SUBTYPE);

			http({
				method: 'GET',
				url: `${DOC_SUBTYPE_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_SUBTYPE_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_SUBTYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_EMAIL_USERS]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_EMAIL_USERS);

			http({
				method: 'GET',
				url: `${USER_URL}/all-users?status=1`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_EMAIL_USERS_SUCCESS, response.data.users);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_EMAIL_USERS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
